import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { ApplicationContextService } from 'src/app/services/application-context.service';

@Injectable({ providedIn: 'root' })
export class CanActivateDisabledTpoMenuItemGuard {
  constructor(
    private readonly _applicationContextService: ApplicationContextService,
    private readonly _router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this._applicationContextService.context.pipe(
      map(ctx => {
        const disabled = ctx?.userPermissions?.disabledTPOAppMenuItems ?? [];
        const menuKey = (next.data?.['menuKey'] as string) || '';
        if (!menuKey) {
          return true;
        }

        if (disabled.includes(menuKey)) {
          return this._router.createUrlTree(['/tpo/dashboard']);
        }

        return true;
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(next, state);
  }
}
